export type FeatureFlagProcessingPlan = {
    packageId: string;
    stage: 'Interpretation' | 'Preparation';
    reason?: string | null;
    token: string;
};

export type PackageFeatureFlagsPreview = {
    packageId: string;
    fileName: string;
    plan?: FeatureFlagProcessingPlan | null;
    reason?: string | null;
};

export const featureFlagProcessingLabels = {
    Interpretation: {
        action: 'Reprocess',
        save: 'Save and reprocess',
        saveSuccess: 'Package feature flags saved. Reprocessing with retained OCR and previews.'
    },
    Preparation: {
        action: 'Reparse',
        save: 'Save and reparse',
        saveSuccess: 'Package feature flags saved. Reparsing the document and generating previews.'
    }
};
